import React, {useState, useEffect} from "react";
import styles from "./index.css";
import PropTypes from "prop-types";

const AvatarText = ({ allInitials = "", fullName = "", nameStyles = {}, bodyStyles = {}, email = "" }) => {
    const [initials, setInitials] = useState("");
    useEffect(() => {
        if (allInitials && allInitials?.trim()) {
            setInitials(allInitials?.trim()?.toUpperCase());
        } else if (fullName && fullName?.trim()) {
            const name = fullName?.trim()?.split(" ").filter(Boolean);
            const firstInitial = name[0] ? name[0][0] : "";
            setInitials(firstInitial?.toUpperCase());
        } else if (email && email?.trim()) {
            const firstChar = email?.trim()?.[0] || "";
            setInitials(firstChar?.toUpperCase());
        } else {
            setInitials("");
        }
    }, [allInitials, fullName, email]);
    return (
        <div styleName={"styles.avatarWrapper"} style={{...bodyStyles}} className="avatarTextBody">
            <h1 style={{...nameStyles}} className="avatarTextName">{initials}</h1>
        </div>
    );
};

AvatarText.propTypes = {
    allInitials: PropTypes.string,
    fullName: PropTypes.string,
    email: PropTypes.string,
    nameStyles: PropTypes.object,
    bodyStyles: PropTypes.object
};

export default AvatarText;
